export default {
  stepPrepare: "Prepare Payment",
  stepProcess: "Process Payment",
  stepConfirm: "Confirm Order",
  preparing: "Preparing payment environment",
  confirmingPayment: "Confirming payment",
  confirmingOrder: "Confirming order",
  possibleIssue: "Possible issue detected",
  settingUp: "Setting up secure checkout…",
  waitingConfirmation: "Waiting for transaction confirmation…",
  updatingAccount: "Updating your account information…",
  paymentSuccessful: "Payment Successful!",
  upgradeSuccess: "Your plan has been upgraded successfully.",
  continue: "Continue",
  somethingWentWrong: "Something went wrong with your payment.",
  tryAgain: "Try Again",
  paymentCancelled: "Payment Cancelled",
  cancelledTransaction: "You closed the payment window or cancelled the transaction.",
  timeoutMessage:
    "Something may have gone wrong. You can check if your benefits have taken effect. If you need help, please contact our support at {supportEmail}.",
  secureEncrypted: "Your payment details are securely encrypted",
  havingTrouble: "Having trouble? Contact {supportEmail}",
};
